import { useCallback } from 'react';
import {
  PermanentConfirmStrategy,
  useConfirmationModal,
} from '~/_shared/components/modal/confirmation/useConfirmationModal';
import { useTranslation } from '~/_shared/utils/hooks';

export const navigationDisclaimerPermanentConfirmSettings = {
  id: 'navigation-address-disclaimer',
  strategy: PermanentConfirmStrategy.Local,
};

export const useNavigationDisclaimerConfirmation = () => {
  const { openConfirmationModal, closeConfirmationModal } = useConfirmationModal();
  const [t] = useTranslation();

  const confirmNavigationDisclaimer = useCallback((onConfirm: () => void) => {
    openConfirmationModal({
      title: t('Heads up'),
      text: t('navigationDisclaimer.description'),
      confirmCaption: t('Continue'),
      onConfirm: () => {
        onConfirm();
        closeConfirmationModal();
      },
      permanentConfirmSettings: navigationDisclaimerPermanentConfirmSettings,
    });
  }, [closeConfirmationModal, openConfirmationModal, t]);

  return { confirmNavigationDisclaimer };
};
